// extracted by mini-css-extract-plugin
export default {"container":"CreateRollingPaperPage_container__7XHsb"};